import styled from 'styled-components';

import { PosterViewItem } from '../app/poster-view.styled';

export const TemperatureStyled = styled(PosterViewItem)``;
